export default {
  index: [
    {
      path: '/InventoryForm',
      component: resolve => require(['./InventoryFormIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/InventoryForm/_router.js